var r = function r(o, s) {
    var e;
    return function () {
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }
      var c = function c() {
        clearTimeout(e), o.apply(void 0, t);
      };
      clearTimeout(e), e = setTimeout(c, s);
    };
  },
  n = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
export { r, n as u };